'use client'

import * as Sentry from '@sentry/nextjs'
import { useMemo } from 'react'

import ADiscountsSection from '@/_components/sections/discounts/components/a-discounts-section'
import { Skeleton } from '@/_components/ui/skeleton'
import ZSuspenseError from '@/_components/universal/z-suspense-error'
import { useSectionParams } from '@/_i18n/section-params'
import { useGetPriceListPromotions } from '@/app/_core/services/price-list-promotions.service'

import ZHomeSectionLayout, {
	ZHomeSectionLayoutDescription,
	ZHomeSectionLayoutTitle
} from './_components/z-home-section-layout'

const AHomeDiscountSkeletonCard = () => (
	<Skeleton className='h-full w-full rounded-2xl min-h-[148px]' />
)

const AHomeDiscounts = ({ className }: { className?: string }) => {
	const { getSectionParams } = useSectionParams('discounts')
	const { data: priceListPromotions, isPending, isError, error } = useGetPriceListPromotions()

	const sectionTitle = (
		<ZHomeSectionLayoutTitle
			title='Akciová ponuka pre vaše zdravie'
			className='max-w-[590px]'
		/>
	)
	const sectionDescription = (
		<ZHomeSectionLayoutDescription description='Objavte špeciálne zľavy na vybrané vyšetrenia a služby polikliniky. Doprajte si porciu zdravia výhodnejšie.' />
	)

	const previewPromotions = useMemo(
		() => (priceListPromotions?.data ?? []).slice(0, 4),
		[priceListPromotions?.data]
	)

	if (isPending) {
		return (
			<ZHomeSectionLayout
				title={sectionTitle}
				description={sectionDescription}
				id={getSectionParams('discounts')}
				className={className}
			>
				<div className='grid grid-cols-1 lg:grid-cols-2 gap-3 max-w-6xl mx-auto'>
					{Array.from({ length: 4 }, (_, i) => (
						<AHomeDiscountSkeletonCard key={i} />
					))}
				</div>
			</ZHomeSectionLayout>
		)
	}

	if (isError) {
		if (error) {
			Sentry.captureException(error)
		}

		return <ZSuspenseError title='Nepodarilo sa načítať akciovú ponuku' />
	}

	return (
		<ZHomeSectionLayout
			title={sectionTitle}
			description={sectionDescription}
			id={getSectionParams('discounts')}
			className={className}
		>
			<ADiscountsSection priceListPromotions={previewPromotions} showAllButton />
		</ZHomeSectionLayout>
	)
}

export default AHomeDiscounts
